import { FC, useCallback, useState } from 'react'

import styled from 'styled-components'
import { useIntercom } from 'react-use-intercom'

import { ArrowButton } from 'src/Components/Buttons/ArrowButton'
import { MAX_MOBILE_WIDTH, variables } from 'src/Styled/variables'
import {
  FaqsAnswersItem,
  FaqsAnswersList,
  FaqsItem,
  FaqsText,
  FaqsTitle,
} from 'src/Pages/Artist/CreateCampaignPage/Components/FaqComponent/styles'

import { PrimaryDottedButton } from '../Buttons/PrimaryDottedButton'

import { AdsFAQItems } from './AdsFAQItems'

const Container = styled.div`
  display: flex;
  width: 100%;
  max-width: 800px;
  margin: 40px auto 0;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  @media screen and (min-width: ${MAX_MOBILE_WIDTH}) {
    margin: 64px auto 0;
  }
`
export const FaqsHeader = styled.span`
  font-family: 'Segoe UI';
  font-size: ${variables.fontSize18};
  font-style: normal;
  font-weight: ${variables.fontWeight600};
  line-height: 150%;
  color: ${({ theme }) => theme.color.darkGrey};
  align-self: flex-start;
`

export const FaqsList = styled.ul`
  padding: 0px;
  list-style-type: none;
  list-style: none;
  display: grid;
  scrollbar-width: none;
  -ms-overflow-style: none;
  width: 100%;
  gap: 16px;
  &::-webkit-scrollbar {
    display: none;
  }
  white-space: break-spaces;
`

export const AdsFAQ: FC = () => {
  const { show } = useIntercom()
  const [activeItemId, setActiveItemId] = useState<number | null>(null)

  const toggleActiveItem = useCallback(
    (id: number): void => {
      if (activeItemId === id) {
        return setActiveItemId(null)
      }
      setActiveItemId(id)
    },
    [activeItemId],
  )
  const handleClick = (): void => {
    show()
  }

  const content = AdsFAQItems.map((item) => {
    const isActive = item.id === activeItemId

    return (
      <FaqsItem key={item.id} isActive={isActive}>
        <FaqsTitle onClick={() => toggleActiveItem(item.id)}>
          {item.question}
          <ArrowButton isDown={isActive} />
        </FaqsTitle>

        {isActive && (
          <FaqsText>
            <FaqsAnswersList>
              <FaqsAnswersItem>{item.answer}</FaqsAnswersItem>
            </FaqsAnswersList>
          </FaqsText>
        )}
      </FaqsItem>
    )
  })
  return (
    <Container>
      <FaqsHeader>FAQs</FaqsHeader>
      <FaqsList>{content}</FaqsList>
      <PrimaryDottedButton onClick={handleClick}>
        Have another question?
      </PrimaryDottedButton>
    </Container>
  )
}
